export default {
	title: 'temperature_automation',
	components: [{ title: 'temperature_automation', component: 'ext_temperature_actions' }],
};
